import WidgetPopulationWithInternet from "./widget-population-with-internet";

export default WidgetPopulationWithInternet;